export default __webpack_public_path__ + "static/media/shopee.c4e2c48e.svg";